// Ficha de producto: suma al selector de colores los productos hermanados (custom.rep = "Hermanar").
// Los <li> los renderiza snippets/moddo-color-picker-information.liquid en #hermanados-colors-template.
// colors-list.js reescribe el contenedor de forma asíncrona, así que se espera a que tenga su <ul>.

document.addEventListener('DOMContentLoaded', function () {
  const template = document.getElementById('hermanados-colors-template');
  const container = document.querySelector('.product-color-picker .color__information .color__list_picker');
  if (!template || !container) return;

  const items = [...template.content.querySelectorAll('li')];
  if (!items.length) return;

  const apply = () => {
    const ul = container.querySelector('ul');
    if (!ul) return false;

    for (const item of items) {
      const color = item.getAttribute('data-color');
      if (ul.querySelector(`li[data-color="${CSS.escape(color)}"]`)) continue;
      ul.appendChild(item.cloneNode(true));
    }
    return true;
  };

  // colors-list.js hace innerHTML = '' + append del <ul>; reaplicamos (idempotente) cada vez que se reconstruye.
  new MutationObserver(apply).observe(container, { childList: true });
  apply();
});
